import { FundingSource } from 'further-types/lp/investment';

export const FundingSourceLabels = {
  [FundingSource.CapitalCall]: 'Capital call',
  [FundingSource.GeneralCapitalOnAccounts]: 'General capital on accounts',
};
